export default [
  {
    id: 1,
    name: {
      en: "binged",
      nl: "vreetbui"
    }
  },
  {
    id: 2,
    name: {
      en: "purged",
      nl: "overgegeven"
    }
  },
  {
    id: 3,
    name: {
      en: "restricted",
      nl: "beperkt"
    }
  },
  {
    id: 4,
    name: {
      en: "weighed",
      nl: "gewogen"
    }
  },
  {
    id: 5,
    name: {
      en: "exercised excessively",
      nl: "overmatig gesport"
    }
  }
];
// export { behaviours as default };
